module.exports = __webpack_public_path__ + "static/img/move_product_03.f2bcc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/move_product_03.png
// module id = lfOr
// module chunks = 0